module.exports = __webpack_public_path__ + "img/artillery-wagon-base-14.a6cca595.png";